import { useQuery } from '@apollo/client';
import { OwlIllustration } from '@/components/Icons.tsx';
import { TypoHeading } from '@/components/Typography.tsx';
import USER_AVATAR from '@/graphql/queries/user-avatar.graphql';
import useAuth from '@/hooks/useAuth.ts';
import useUser from '@/hooks/useUser.ts';
import { getAvatarBackground, getAvatarUrl } from '@/utils/avatars.ts';

const UserInfo = ({ className = '' }: { className?: string }) => {
  const { user } = useUser();

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <UserAvatar />
      <TypoHeading className="text-neutral2-text-softer">
        {user?.profileName ?? '-'}
      </TypoHeading>
    </div>
  );
};

// Kept out of the ClientInfo fragment: if the avatar can't load, the rest of the user info still does.
const UserAvatar = () => {
  const auth = useAuth();
  const { data } = useQuery(USER_AVATAR, { skip: !auth.clientId });
  const avatar = data?.user;
  // The avatar is picked during the app's onboarding; until then it's the owl.
  const url = avatar?.applicationOnboarded ? getAvatarUrl(avatar.avatarIdx) : undefined;
  const className = 'w-10 h-10 shrink-0 rounded-full border-2 border-neutral2-text-softer';
  const background = getAvatarBackground(avatar?.avatarBackgroundIdx);

  if (!url) return <OwlIllustration width="40" height="40" className={className} />;

  return (
    <span className={`${className} overflow-hidden`} style={{ background }}>
      <img src={url} alt="" className="w-full h-full" />
    </span>
  );
};

export default UserInfo;
